<header class="portal-header">
  <div class="portal-header__brand">
    <a class="brand-lockup" routerLink="/dashboard" [attr.aria-label]="'common.appName' | translate">
      <img class="mp-government-logo" src="https://mpurban.gov.in/images/header/30112019040958a.png" alt="Government of Madhya Pradesh" />
      <span class="mp-government-title"><b>नगरीय विकास एवं आवास विभाग</b><small>Urban Development &amp; Housing Department</small></span>
    </a>

    <button class="menu-toggle" type="button" (click)="menuToggle.emit()" [attr.aria-expanded]="!sidebarCollapsed()" [attr.aria-label]="(sidebarCollapsed() ? 'navigation.showMenu' : 'navigation.hideMenu') | translate">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </button>
  </div>

  <div class="portal-header__account">
    <div class="portal-header__language">
      <i class="bi bi-globe2" aria-hidden="true"></i>
      <app-language-switcher />
    </div>
    <button class="portal-header__profile" type="button" (click)="openProfile()" aria-label="Open profile settings">
      @if (profilePhotoUrl(); as photoUrl) { <img class="portal-header__photo" [src]="photoUrl" [alt]="userName()" (error)="profileImageFailed()" /> } @else { <span class="portal-header__initials" aria-hidden="true">{{ initials() }}</span> }
      <span class="portal-header__user"><strong>{{ userName() }}</strong><small>{{ roleName() }}</small></span>
    </button>
    <div class="settings-split">
      <button class="settings-split__toggle settings-split__toggle--account" type="button" (click)="toggleSettingsMenu()" [attr.aria-expanded]="settingsMenuOpen()" aria-label="Open account menu" title="Account options">
        <i class="bi bi-gear" aria-hidden="true"></i>
        <i class="bi bi-chevron-down" aria-hidden="true"></i>
      </button>
      @if(settingsMenuOpen()) {
        <div class="settings-menu">
          <button type="button" (click)="openProfile()"><i class="bi bi-camera"></i><span><strong>Upload profile picture</strong><small>Update photo and account settings</small></span></button>
          <button class="settings-menu__logout" type="button" (click)="signOut()"><i class="bi bi-box-arrow-right"></i><span><strong>{{ 'common.signOut' | translate }}</strong><small>End your current session</small></span></button>
        </div>
      }
    </div>
  </div>
</header>
@if (profileOpen()) { <app-profile-settings (closed)="closeProfile()" /> }
